import { useZapierChatbot } from '~/composables/useZapierChatbot'

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.client) {
    const { isPathAllowed, injectScript, removeScript } = useZapierChatbot()

    if (isPathAllowed(to.path)) {
      injectScript()
    }
    else {
      removeScript()
    }
  }
})
